export default __webpack_public_path__ + "9d77f18e7618cbb50c17c9e421941266.png";